import { ApiError, ApiNetworkError } from "@commerce-os/api-client";

import type { T } from "./i18n";

/**
 * What to tell the user about a failed call: the message for its stable `code` in their language (never the
 * API's English `detail`), plus the request ID to quote when reporting it.
 */
export function describeError(t: T, error: unknown): { message: string; reference?: string } {
  if (error instanceof ApiError) {
    const message = planMessage(t, error) ?? t(`errors:${error.code}`);
    return error.requestId === undefined
      ? { message }
      : { message, reference: t("states.errorReference", { requestId: error.requestId }) };
  }
  if (error instanceof ApiNetworkError) return { message: t("states.offline") };
  return { message: t("states.error") };
}

const PLAN_THINGS = ["locations", "users", "devices", "products", "orders"] as const;

/** "Your plan allows 3 locations…" when the API said which limit was reached (docs/specs/platform.md Part 2). */
function planMessage(t: T, error: ApiError): string | undefined {
  const { entitlement } = error;
  if (error.code !== "PLAN_LIMIT_REACHED" || entitlement?.limit === undefined || entitlement.limit === null) {
    return undefined;
  }
  const thing = PLAN_THINGS.find((name) => entitlement.key.startsWith(`${name}.`));
  if (thing === undefined) return undefined;
  return t("plan.limitReached", { limit: entitlement.limit, thing: t(`plan.things.${thing}`) });
}
